export var BADGE_SIZE = 30;